import { render, staticRenderFns } from "./claimResponsibilityList.vue?vue&type=template&id=da8ac420&scoped=true"
import script from "./claimResponsibilityList.vue?vue&type=script&lang=js"
export * from "./claimResponsibilityList.vue?vue&type=script&lang=js"
import style0 from "./claimResponsibilityList.vue?vue&type=style&index=0&id=da8ac420&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da8ac420",
  null
  
)

export default component.exports